import Bowser from "bowser";

export const BROWSERS = [
  {
    id: "chrome",
    name: "Chrome"
  },
  {
    id: "firefox",
    name: "Firefox"
  },
  {
    id: "safari",
    name: "Safari"
  },
  {
    id: "msie",
    name: "Internet Explorer"
  },
  {
    id: "opera",
    name: "Opera"
  },
  {
    id: "edge",
    name: "Microsoft Edge"
  },
  {
    id: "webkit",
    name: "WebKit-based"
  },
  {
    id: "unknown",
    name: "Unknown"
  }
];

export const DEVICES = [
  {
    id: "windows",
    name: "Windows"
  },
  {
    id: "android",
    name: "Android"
  },
  {
    id: "macos",
    name: "Mac OS"
  },
  {
    id: "iphone",
    name: "iPhone"
  },
  {
    id: "ipad",
    name: "iPad"
  },
  {
    id: "linux",
    name: "Linux"
  },
  {
    id: "chromeos",
    name: "Chrome OS"
  },
  {
    id: "unknown",
    name: "Unknown"
  }
];

export const CHANNELS = [
  {
    id: "chat",
    name: "Ada Web Chat"
  },
  {
    id: "messenger",
    name: "Facebook Messenger"
  },
  {
    id: "whatsapp",
    name: "WhatsApp"
  },
  {
    id: "sms",
    name: "SMS"
  },
  {
    id: "mobile_sdk",
    name: "Mobile SDK"
  }
];

/**
 * ⚠️⚠️ NOTE ⚠️⚠️ Browser detection is not always reliable and should only be used as a last resort
 * Perhaps you want feature detection instead?
 * see https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
 * for more info on why it should be avoided
 */
export const detectBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);

  return browser;
};

/**
 * Checks if the users browser is Chrome
 * @returns {Boolean}
 */
export function isChrome() {
  return detectBrowser().getBrowserName() === "Chrome";
}

/**
 * @returns {Boolean}
 */
export function isSelenium() {
  return navigator.userAgent.toLowerCase().indexOf("selenium") > -1;
}

/**
 * Checks if the users browser platform is desktop
 * @returns {Boolean}
 */
export function isDesktop() {
  return detectBrowser().getPlatformType() === "desktop";
}

/**
 * Checks if the users browser platform is Chrome desktop
 * @returns {Boolean}
 */
export function isChromeDesktop() {
  return isChrome() && isDesktop();
}

/**
* Checks if the users browser is Desktop Chrome
* https://stackoverflow.com/questions/4565112/
*   javascript-how-to-find-out-if-the-user-browser-is-chrome
* @returns {Boolean}
*/
export function isChromeDesktopLegacy() {
  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof window.opr !== "undefined";
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
  const isChromeLegacy = isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false;

  return isChromeLegacy;
}
